import { Tooltip } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addCartRequest } from "../../store/shopping/shopping.actions";
import { getImage } from "../../store/user/user.selector";
import _ from "underscore";
import Swal from "sweetalert2";

const ProductDetail = (props) => {
    const dispatch = useDispatch();
    const history = useNavigate();
    const { product, livestream, cart, hidden } = props;
    const [stockQuantity, setstockQuantity] = useState("");
    const [qty, setQty] = useState(0);

    useEffect(() => {
        setstockQuantity(product.warehouse && product.warehouse.remaining);
        if (cart.cartItems) {
            let cartPro = _.find(cart.cartItems, x => x.product._id === product._id);
            if (cartPro) {
                setQty(cartPro.quantity)
            }
        }
    }, [product, cart])

    return (
        <div key={product._id} className="mb-5">
            <div className="px-3.5 py-5 border border-black-10 rounded-md bg-white">
                <div className="grid grid-cols-2 gap-x-[18px]">
                    <div className="">
                        <ImageGallery
                            showNav={false}
                            showPlayButton={false}
                            items={
                                product.allAttachments
                                    .length > 0
                                    ? product.allAttachments
                                        .concat(
                                            product.attachments
                                        )
                                        .map((x) => {
                                            return {
                                                thumbnailWidth: 32,
                                                thumbnailHeight: 32,
                                                id: x._id,
                                                original:
                                                    getImage(
                                                        x
                                                    ),
                                                thumbnail:
                                                    getImage(
                                                        x
                                                    ),
                                            };
                                        })
                                    : [
                                        {
                                            thumbnailWidth: 32,
                                            thumbnailHeight: 32,
                                            id: product
                                                .attachments
                                                ._id,
                                            original:
                                                getImage(
                                                    product.attachments
                                                ),
                                            thumbnail:
                                                getImage(
                                                    product.attachments
                                                ),
                                        },
                                    ]
                            }
                        />
                    </div>
                    <div className="">
                        <h5 className="text-md text-black-100">
                            {product.name}
                        </h5>
                        <p className="text-sm font-medium text-orange-color uppercase mb-1.5">
                            {product.currency}{" "}
                            {product.price.toFixed(2)}
                        </p>

                        <p className="text-extraSmall font-medium text-black capitalize mb-[1px]">
                            Stock Quantity:{" "}
                            {parseFloat(stockQuantity) - parseFloat(qty) > 0 ? parseFloat(stockQuantity) - parseFloat(qty) : 0}
                        </p>
                        <Tooltip
                            title={product.descriptions}
                        >
                            <p
                                className="text-sm font-normal text-black-50"
                                style={{
                                    overflow: "hidden",
                                    textOverflow:
                                        "ellipsis",
                                }}
                            >
                                {product.descriptions
                                    .length > 100
                                    ? product.descriptions.slice(
                                        0,
                                        100
                                    ) + "..."
                                    : product.descriptions}
                            </p>
                        </Tooltip>
                    </div>
                </div>
                {
                    !hidden &&
                    <div className=" flex items-center gap-5 mt-5">
                        {
                            product.warehouse.remaining === qty || product.warehouse.remaining < 0 || parseFloat(stockQuantity) - parseFloat(qty) < 0 ?
                                <button
                                    className="py-[7px] w-full block capitalize rounded-lg text-sm border border-orange-color text-orange-color whitespace-nowrap"
                                    onClick={() => {
                                        Swal.fire({
                                            title: 'Reminder Set',
                                            text: "You will get a future notification when this item is available.",
                                            icon: 'success',
                                            showCancelButton: true,
                                            cancelButtonColor: 'green',
                                            showConfirmButton: false,
                                            cancelButtonText: "Close",
                                            customClass: {
                                                cancelButton: 'order-1 right-gap',
                                                confirmButton: 'order-2',
                                                denyButton: 'order-3',
                                            }
                                        });
                                    }} >
                                    Remind&nbsp;me
                                </button> :
                                <button
                                    onClick={() => {
                                        dispatch(
                                            addCartRequest({
                                                product: product._id,
                                                quantity: 1,
                                                livestream:
                                                    livestream._id,
                                            })
                                        );
                                    }}
                                    className="py-[7px] w-full block capitalize rounded-lg text-sm font-medium bg-white border border-black-10 text-black-50 whitespace-nowrap"
                                >
                                    Add to Cart
                                </button>
                        }
                        {
                            product.warehouse.remaining === qty || product.warehouse.remaining < 0 || parseFloat(stockQuantity) - parseFloat(qty) < 0 ?
                                <button
                                    className="py-[7px] w-full block capitalize rounded-lg text-sm border border-orange-color text-orange-color whitespace-nowrap"
                                >
                                    Not&nbsp;available
                                </button>
                                :
                                <button
                                    onClick={() => {
                                        dispatch(
                                            addCartRequest({
                                                product: product._id,
                                                quantity: 1,
                                                livestream:
                                                    livestream._id,
                                                history: history,
                                                canNavigate: true,
                                            })
                                        );
                                    }}
                                    className="py-[7px] w-full block capitalize rounded-lg text-sm font-bold bg-orange-color text-white whitespace-nowrap"
                                >
                                    Buy it Now
                                </button>
                        }
                    </div>
                }
            </div>
        </div>
    );
};

export default ProductDetail;
